<template>
    <div>
        <Poptip placement="bottom" :transfer="false">
            <Badge :count="unreadCount">
                <Icon type="turbo-ui-bell" />
            </Badge>
            <Tabs slot="content" :animated="false">
                <TabPane v-for="cate in msgCate" :label="cate.name" :name="cate.name">
                    <div v-if="unreadMsg[cate.id] && unreadMsg[cate.id].categoryCount > 0">
                        <div v-for="unreadItem in unreadMsg[cate.id]">
                            <div  v-if="unreadItem.count > 0 ">
                                <a @click="jumpNotification(unreadItem.typeId)" class="msg" v-if="cate.id===1 && unreadItem.typeId != 888">
                                    <span class="unread-count">{{unreadItem.count || 100}}</span><span class="unread-desc">{{'条'+unreadItem.typeDesc.replace('消息','')}}</span>
                                </a>
                                <a @click="jumpOther(OtherMsgTypesMap[unreadItem.typeId])" class="msg" v-if="cate.id!==1 || unreadItem.typeId===888">
                                    <span class="unread-count">{{unreadItem.count}}</span><span class="unread-desc">{{'条'+unreadItem.typeDesc.replace('消息','')}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <a class="msg" href="javascript:void(0)">
                            <span class="unread-desc">当前无消息</span>
                        </a>
                    </div>
                    <div class="bordertop" v-if="cate.id === 1">
                        <a class="see-all" @click="gotoMessageCenter">查看全部<i class="icon icon-arrow-right"></i></a>
                    </div>
                </TabPane>
            </Tabs>
        </Poptip>
    </div>
</template>
<script>
    import { NoticeIcon } from '@hfe/turbos'
    import { MsgCategories, OtherMsgTypesMap } from 'data/notification'
    export default {
        components: {
        },
        data() {
            return {
                unreadMsg: {},
                unreadCount: 0,
                msgCate: MsgCategories,
                OtherMsgTypesMap
            }
        },
        computed: {
            unreadMap () {
                return this.$store.state.unreadMap
            }
        },
        watch: {
            unreadMap: function () {
                if (this.getNotificationUnread(this.unreadMap)) {

                }
            }
        },
        methods: {
            getNotificationUnread: function (unreadMap) {
                if (unreadMap && (unreadMap[1] || unreadMap[2] || unreadMap[3])) {
                    this.unreadMsg = unreadMap;
                    let totalCount = 0;
                    Object.keys(unreadMap).forEach((keyCurr) => {
                        let unreadItems = unreadMap[keyCurr];
                        let categoryCount = 0;
                        if (unreadItems && unreadItems.length) {
                            unreadItems.forEach((unreadItem) => {
                                if (unreadItem) {
                                    let msgCount = Number.parseInt(unreadItem.count);
                                    if (msgCount && msgCount > 0) {
                                        categoryCount += msgCount;
                                    }
                                }
                            });
                            if (categoryCount > 0) {
                                totalCount += categoryCount;
                            }
                        }
                        unreadItems.categoryCount = categoryCount;
                    });
                    this.unreadMsg.length = totalCount;
                    this.unreadCount = totalCount;
                    return true;
                }
                return false;
            },
            gotoMessageCenter() {
                this.$router.push({name: 'verify'})
            },
            jumpNotification(categoryId) {
                this.$router.push({name: 'verify', query: {categoryId}})
            },
            jumpOther(obj) {
                this.$router.push({ name: obj.stateName, query: obj.params })
            }
        }
    }
</script>
<style lang="postcss" type="text/postcss">
    .msg-center .tbo-tabs-nav {
        width: 100%;
        display: flex;
    }

    .msg-center .tbo-tabs-tab:last-child {
        margin-right: 0;
    }

    .msg-center .tbo-tabs-tab {
        flex: 1;
        text-align: center;
    }

    .msg-center {
        .bordertop {
            height: 37px;
            text-align: center !important;
            border-top: 1px solid #e9ecf2;
            padding-top: 10px;
        }
        .see-all {
            padding: 11px 25px !important;
            color: #626566;
            line-height: 14px;
        }
        .msg {
            display: block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-size: 12px;
            color: #4c4e50;
            cursor: pointer;
            text-decoration:none;
            padding-bottom: 10px;
        }

    }

</style>



// WEBPACK FOOTER //
// messageCenter.vue?45039330